export default __webpack_public_path__ + "static/media/star.479d4f15.svg";